'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeListPage$ColumnType$() {
  this.lr = null;
  this.nC = null;
  this.mD = false;
  this.dv = 0;
  this.al = null;
  this.nB = 0;
  this.jj = 0;
  this.oO = null;
  this.oP = false;
  this.oQ = null;
  this.oR = false;
  this.ZR = null;
  this.ZP = null;
  this.ZN = null;
  this.ZS = null;
  this.ZO = null;
  this.ZQ = null;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_s_Enumeration__I__(this, 0);
  $n_Lmealorama_pages_RecipeListPage$ColumnType$ = this;
  var name = (((this.al !== null) && this.al.l()) ? this.al.k() : "nameColumn");
  this.ZR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name);
  var name$1 = (((this.al !== null) && this.al.l()) ? this.al.k() : "cuisineColumn");
  this.ZP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$1);
  var name$2 = (((this.al !== null) && this.al.l()) ? this.al.k() : "courseColumn");
  this.ZN = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$2);
  var name$3 = (((this.al !== null) && this.al.l()) ? this.al.k() : "ratingColumn");
  this.ZS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$3);
  var name$4 = (((this.al !== null) && this.al.l()) ? this.al.k() : "createdColumn");
  this.ZO = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$4);
  var name$5 = (((this.al !== null) && this.al.l()) ? this.al.k() : "lastMadeColumn");
  this.ZQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Enumeration$Val(this, this.dv, name$5);
}
export { $c_Lmealorama_pages_RecipeListPage$ColumnType$ as $c_Lmealorama_pages_RecipeListPage$ColumnType$ };
$p = $c_Lmealorama_pages_RecipeListPage$ColumnType$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Enumeration();
$p.constructor = $c_Lmealorama_pages_RecipeListPage$ColumnType$;
/** @constructor */
function $h_Lmealorama_pages_RecipeListPage$ColumnType$() {
}
export { $h_Lmealorama_pages_RecipeListPage$ColumnType$ as $h_Lmealorama_pages_RecipeListPage$ColumnType$ };
$h_Lmealorama_pages_RecipeListPage$ColumnType$.prototype = $p;
var $d_Lmealorama_pages_RecipeListPage$ColumnType$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeListPage$ColumnType$, "mealorama.pages.RecipeListPage$ColumnType$", ({
  Ls: 1,
  aX: 1,
  a: 1
}));
export { $d_Lmealorama_pages_RecipeListPage$ColumnType$ as $d_Lmealorama_pages_RecipeListPage$ColumnType$ };
var $n_Lmealorama_pages_RecipeListPage$ColumnType$;
function $m_Lmealorama_pages_RecipeListPage$ColumnType$() {
  if ((!$n_Lmealorama_pages_RecipeListPage$ColumnType$)) {
    $n_Lmealorama_pages_RecipeListPage$ColumnType$ = new $c_Lmealorama_pages_RecipeListPage$ColumnType$();
  }
  return $n_Lmealorama_pages_RecipeListPage$ColumnType$;
}
export { $m_Lmealorama_pages_RecipeListPage$ColumnType$ as $m_Lmealorama_pages_RecipeListPage$ColumnType$ };
//# sourceMappingURL=mealorama.pages.-Recipe-List-Page$-Column-Type$.js.map
